import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'
import router from './router/index.js' // Pastikan path router benar
import '@fortawesome/fontawesome-free/css/all.min.css';


const app = createApp(App)

app.use(router) // Tambahkan router ke aplikasi
app.mount('#app') // Mount ke #app
